import { render, staticRenderFns } from "./OrderOtpVerification.vue?vue&type=template&id=47f692de&"
import script from "./OrderOtpVerification.vue?vue&type=script&lang=js&"
export * from "./OrderOtpVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports